<div class="p-8 border rounded-lg bg-card">
    <div class="pb-4 border-b flex justify-between items-center">
        <div>
            <h2 class="text-xl font-semibold">Review and Download</h2>
            <p class="mt-1 text-secondary">Review the new translations, make edits, and download the final files.</p>
        </div>
        <button mat-flat-button color="primary" (click)="downloadResults()">
            <mat-icon>download</mat-icon>
            <span>Download Files</span>
        </button>
    </div>

    <div class="mt-6">
        <mat-form-field class="w-full sm:w-1/3">
            <mat-label>Review Language</mat-label>
            <mat-select [value]="selectedLanguage" (valueChange)="onLanguageChange($event)">
                <mat-option *ngFor="let lang of wizardData.targetLanguages" [value]="lang">
                    {{ lang | uppercase }}
                </mat-option>
            </mat-select>
        </mat-form-field>
    </div>

    <div class="mt-4 border rounded-lg overflow-hidden">
        <div class="grid grid-cols-12 gap-4 p-4 bg-gray-50 dark:bg-gray-800 font-semibold">
            <div class="col-span-4">Key</div>
            <div class="col-span-4">Base ({{ wizardData.baseLanguage | uppercase }})</div>
            <div class="col-span-4">Translation ({{ selectedLanguage | uppercase }})</div>
        </div>

        <div class="max-h-[60vh] overflow-y-auto">
            <div *ngFor="let item of comparisonData; trackBy: trackByKey"
                 class="grid grid-cols-12 gap-4 p-4 border-t items-center hover:bg-gray-50 dark:hover:bg-gray-800/50"
                 [class.border-l-4]="item.isNew"
                 [class.border-l-green-500]="item.isNew">

                <div class="col-span-4 font-mono text-sm text-secondary break-all">{{ item.key }}</div>
                <div class="col-span-4 text-sm">{{ item.baseValue }}</div>
                <div class="col-span-4">
                    <textarea
                        matInput
                        class="w-full p-2 border rounded-md bg-white dark:bg-gray-700 text-sm"
                        [value]="item.targetValue"
                        [(ngModel)]="item.targetValue"
                        rows="1"
                        cdkTextareaAutosize
                        #autosize="cdkTextareaAutosize"
                    ></textarea>
                </div>
            </div>
            <div *ngIf="comparisonData.length === 0" class="p-8 text-center text-secondary">
                No data to display for this language.
            </div>
        </div>
    </div>
</div>
